import formValidator, {
	required,
	minLen,
	match,
	join,
	rule,
	isTheSame,
	isEmail,
	isCorrectEmailLen,
	maxLen,
} from "@insightfulscience/shared-utils/validation";

export const initialState = {
	firstName: "",
	lastName: "",
	company: "",
	email: "",
	password: "",
	pswdConfirm: "",
};

const schema = {
	firstName: [required, "errors.FIRST_NAME_REQUIRED"],
	lastName: [required, "errors.LAST_NAME_REQUIRED"],
	email: [
		[required, "errors.EMAIL_REQUIRED"],
		[isCorrectEmailLen(64), "errors.EMAIL_INVALID_LENGTH"],
		[isEmail, "errors.WRONG_EMAIL"],
	],
	password: [
		[required, "errors.PSWD_REQUIRED"],
		join(
			rule(minLen(6), "$t(errors.PSWD_TOO_SHORT)"),
			rule(maxLen(64), "$t(errors.PSWD_TOO_LONG)"),
			rule(match(/\d/), "$t(errors.PSWD_AT_LEAST_1_DIGIT)"),
		),
	],
	pswdConfirm: [
		[required, "errors.CFRM_PSWD_REQUIRED"], // check 1
		[isTheSame("password"), "errors.CFRM_SHOULD_MATCH_PSWD"], // check 2
	],
};

export const validateForm = formValidator(schema);
